<template>
    <div class="d-flex align-center mb-2">
        <span data-id="issueCardSubject" class="text-h6 mr-4 font-weight-bold">{{ subject }}</span>
        <issues-card-date data-id="issueCardCreatedDate" :date="createdAt" :show-icon="true" :tooltip="t('inquiry.inquiryCreated')" />
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import IssuesCardDate from './IssuesCardDate.vue';
import { IIssuesCardMeta } from '../../types';

const { t } = useI18n();

defineProps<IIssuesCardMeta>();
</script>
